import {StandardChargeCode} from '@shipwell/backend-core-singlerequestparam-sdk';

type ChargeCodesGroupedInCategoriesType = {
  [key: string]: (StandardChargeCode | {label: string; value: string})[];
};
export const groupChargeCodesInCategories = (chargeCodes?: StandardChargeCode[]) =>
  chargeCodes?.reduce<ChargeCodesGroupedInCategoriesType>(
    (acc, chargeCode) => ({...acc, [chargeCode.category]: [...(acc[chargeCode.category] ?? []), chargeCode]}),
    {}
  );
export const groupChargeCodesInlineGroupSelect = (chargeCodes?: StandardChargeCode[]) => {
  const categoryArray = [...new Set(chargeCodes?.map((chargeCode) => chargeCode.category))];
  return categoryArray.map((category) => ({
    label: category,
    options: chargeCodes
      ?.filter((chargeCode) => chargeCode.category === category)
      .map((option) => ({label: option.name, value: option.id, category, chargeCode: option.code}))
  }));
};
